var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('el-button',{staticClass:"batch-operate-btn",attrs:{"type":"text","data-matomo":_vm.$store.state.matomo[27].id},on:{"click":_vm.editGroup}},[_vm._v(" "+_vm._s(_vm.$t("main.grouping"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }